export const SNOWPACK_PUBLIC_BACKEND_ENV = "production";
export const SNOWPACK_PUBLIC_FRONTEND_ENV = "production";
export const SNOWPACK_PUBLIC_SENTRY_DSN = "https://f9acc3a3ed974c4c93dbf467d82a8fe6@o283013.ingest.sentry.io/5880247";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;